<template>
  <div class="content-with-spacing" :class="sidebarClass">
    <div class="dashboard-welcome-container">
      <img src="../../img/edukate_icon.svg" alt="KATE Logo" class="kate-logo">
      <h1>Welcome to the EDUKATE Dashboard</h1>
      <div class="info-card">
        <p class="text-foreground">
          <i class="fas fa-arrow-left-long" aria-hidden="true"></i>Use the sidebar to navigate to your pages and tools.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.dashboard-welcome-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20vh;
}

.dashboard-welcome-container img {
  width: 100px;
  height: 100px;
}

.info-card {
  background-color: var(--kate-panel);
  padding: 25px;
  border-radius: 10px;
  margin-top: 20px;
  box-shadow: 0 0 10px rgb(2 20 23 / 0.5);
}

.info-card p {
  margin: 0;
}

.info-card i {
  margin-right: 10px;
}

.dashboard-welcome-container h1 {
  font-family: hk-grotesk-semibold, sans-serif;
  font-size: 3rem;
  color: var(--kate-type-primary);
  margin-bottom: 0;
  text-align: center;
}
</style>

<style>
[data-theme="light"] .dashboard-welcome-container .info-card {
  box-shadow: 0 0 10px #e1e3f1 !important;
}

[data-theme="dark"] .dashboard-welcome-container .info-card {
  box-shadow: 0 0 10px 0 rgb(13 12 24 / 0.9) !important;
}
</style>

<script>
import SidebarMixin from '@mixins/sidebar-mixin';

export default {
  mixins: [SidebarMixin],

  beforeMount() {
    // Because this is the landing page, and there's nothing to load.
    // Without it, we get an infinite loading spinner.
    this.$Loading.finish();
  },
};
</script>
